import AutorenewIcon from '@mui/icons-material/Autorenew';
import KeyIcon from '@mui/icons-material/Key';
import { Alert, Button, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CopyableContent from 'components/atoms/CopyableContent';
import LabelStyle from 'components/LabelStyle';
import PropTypes from 'prop-types';
import React from 'react';

const DisplayKey = ({ apiKey: { name, key }, handleRegenerateKey }) => {
  const theme = useTheme();

  return (
    <Stack>
      <LabelStyle>Integracion con API disponible</LabelStyle>
      <Stack
        sx={{
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 1,
          p: 2
        }}
        spacing={2}
      >
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" spacing={1} alignItems="center">
            <KeyIcon
              sx={{
                color: theme.palette.warning.main,
                fontSize: '34px'
              }}
            />
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.grey[600],
                fontSize: '22px'
              }}
            >
              {name}
            </Typography>
          </Stack>
          <Button
            variant="outlined"
            startIcon={<AutorenewIcon />}
            onClick={handleRegenerateKey}
          >
            Volver a generar API KEY
          </Button>
        </Stack>

        {key && (
          <CopyableContent
            message="Copia y guarda tu API KEY, cuando salgas de aqui ya no será
                visible"
            contentToCopy={key}
          />
        )}
        <Alert severity="warning">
          <Typography variant="body2">
            Esta API KEY no es editable ni consultable. Si la olvidaste o
            extraviaste genera una nueva.
          </Typography>
        </Alert>
      </Stack>
    </Stack>
  );
};

DisplayKey.propTypes = {
  apiKey: PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string
  }),
  handleRegenerateKey: PropTypes.func
};

export default DisplayKey;
